import Schema from 'AppReact/schema';

export default {
  pageNumber: Schema('integer', 'primitive', { defaultValue: 0 }),
  pageSize: Schema('integer', 'primitive', { defaultValue: 15 }),
  total: Schema('integer', 'primitive', { defaultValue: 0 }),
  isDropdownOpen: Schema('boolean', 'primitive', { defaultValue: false })
};
